import * as types from './_actionTypes';

export const fetchAssessmentsRequest = () => ({
  type: types.FETCH_ASSESSMENTS_REQUEST
});

export const fetchAssessmentsSuccess = (assessments) => ({
  type: types.FETCH_ASSESSMENTS_SUCCESS,
  payload: assessments
});

export const fetchAssessmentsFailure = (error) => ({
  type: types.FETCH_ASSESSMENTS_FAILURE,
  payload: error
});

export const startAssessmentRequest = (assessmentId) => ({
  type: types.START_ASSESSMENT_REQUEST,
  payload: assessmentId
});

export const startAssessmentSuccess = (assessment) => ({
  type: types.START_ASSESSMENT_SUCCESS,
  payload: assessment
});

export const startAssessmentFailure = (error) => ({
  type: types.START_ASSESSMENT_FAILURE,
  payload: error
});

export const submitAssessmentRequest = (assessmentId, answers) => ({
  type: types.SUBMIT_ASSESSMENT_REQUEST,
  payload: { assessmentId, answers }
});

export const submitAssessmentSuccess = (result) => ({
  type: types.SUBMIT_ASSESSMENT_SUCCESS,
  payload: result
});

export const submitAssessmentFailure = (error) => ({
  type: types.SUBMIT_ASSESSMENT_FAILURE,
  payload: error
});

export const updateAssessmentAnswer = (questionId, answer) => ({
  type: types.UPDATE_ASSESSMENT_ANSWER,
  payload: { questionId, answer }
});

export const fetchAssessmentResultsRequest = () => ({
  type: types.FETCH_ASSESSMENT_RESULTS_REQUEST
});

export const fetchAssessmentResultsSuccess = (results) => ({
  type: types.FETCH_ASSESSMENT_RESULTS_SUCCESS,
  payload: results
});

export const fetchAssessmentResultsFailure = (error) => ({
  type: types.FETCH_ASSESSMENT_RESULTS_FAILURE,
  payload: error
});